/* eslint-disable max-len */
export const config = {
  stripePublicLive: 'pk_live_aWiKHBUujhAmYINsvtMVtEqd',
  stripePublicTest: 'pk_test_qgdXOzP1IBfRXiFiAGh7t1V3'
};
